import { Attribute } from './Attribute.js';

export const EINVOICE_NOTIFICATION_TIME_ATTRIBUTE_TYPE = 'EInvoiceNotificationTimeAttribute';
export const DAY_OF_WEEK_ATTRIBUTE_ID = 'Only workdays';
export const TIME_OF_DAY_ATTRIBUTE_ID = 'All day hours';

export const OPTION_NONSTOP = 'nonstop';
export const OPTION_LIMITED = 'limited';
export const OPTIONS = [OPTION_NONSTOP, OPTION_LIMITED];

/**
 * @property {string} value
 * @property {boolean} isReadOnly
 */
export class EInvoiceNotificationTimeAttribute extends Attribute {
  constructor({ value, isReadOnly = false }) {
    super();
    this.value = value;
    this.isReadOnly = isReadOnly;
    this.type = EINVOICE_NOTIFICATION_TIME_ATTRIBUTE_TYPE;
  }

  /**
   *
   * @param {string} value
   */
  set value(value) {
    if (!OPTIONS.includes(value)) {
      throw new Error(`'${value}' is not a valid EInvoiceNotificationTimeAttribute value.`);
    }

    this._value = value;
  }

  /**
   *
   * @return {string}
   */
  get value() {
    return this._value;
  }

  /**
   *
   * @return {string}
   */
  get dayOfWeek() {
    switch (this.value) {
      case OPTION_LIMITED:
        return 'WORKDAYS';
      case OPTION_NONSTOP:
        return 'UNLIMITED';
      default:
        throw new Error('Unknown value.');
    }
  }

  /**
   *
   * @return {string}
   */
  get timeOfDay() {
    switch (this.value) {
      case OPTION_LIMITED:
        return 'DAY-TIME';
      case OPTION_NONSTOP:
        return 'UNLIMITED';
      default:
        throw new Error('Unknown value.');
    }
  }
}
